<script lang="ts">
    import {type SheetMatch} from './src/types';

    export let match:SheetMatch;

    export let homePlayer : string;

    export let visitingPlayer : string;

    export let readonly:boolean = false;

    export let incomplete: boolean = false;

</script>

{#if match && match.home && match.visiting && match.home.length > 0 && match.visiting.length > 0}
    {#if readonly}
        <tr style="width:100% !important">
            <td style="text-align:center">{homePlayer}</td><td>
            <td>{match.home[0]}</td>
            <td>{match.home[1]}</td>
            <td>{match.home[2]}</td>
            <td>{match.home[3]}</td>
            <td>{match.home[4]}</td>
            <td>{match.score_home}</td>
            <td style="text-align:center">{visitingPlayer}</td>
            <td>{match.visiting[0]}</td>
            <td>{match.visiting[1]}</td>
            <td>{match.visiting[2]}</td>
            <td>{match.visiting[3]}</td>
            <td>{match.visiting[4]}</td>
            <td>{match.score_visiting}</td>
        </tr>
    {:else}
        <tr style="width:100% !important"><td>{homePlayer}</td><td>
                <td><input type="number" bind:value={match.home[0]} disabled={incomplete}/></td>
                <td><input type="number" bind:value={match.home[1]} disabled={incomplete}/></td>
                <td><input type="number" bind:value={match.home[2]} disabled={incomplete}/></td>
                <td><input type="number" bind:value={match.home[3]} disabled={incomplete}/></td>
                <td><input type="number" bind:value={match.home[4]} disabled={incomplete}/></td>
                <td>{match.score_home}</td>
            <td>{visitingPlayer}</td>
                <td><input type="number" bind:value={match.visiting[0]} disabled={incomplete}/></td>
                <td><input type="number" bind:value={match.visiting[1]} disabled={incomplete}/></td>
                <td><input type="number" bind:value={match.visiting[2]} disabled={incomplete}/></td>
                <td><input type="number" bind:value={match.visiting[3]} disabled={incomplete}/></td>
                <td><input type="number" bind:value={match.visiting[4]} disabled={incomplete}/></td>
            <td>{match.score_visiting}</td>
        </tr>
    {/if}
{/if}